<template>
  <div class="vx-breadcrumb">
    <ul class="flex flex-wrap items-center">
      <li class="inline-flex items-end">
        <router-link to="/">
          <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 stroke-current text-primary"></feather-icon>
        </router-link>
        <span class="breadcrumb-separator mx-2">
          <feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" />
        </span>
      </li>
      <template v-if="$route.meta.breadcrumb.length > 0">
        <li
          v-for="(link, index) in $route.meta.breadcrumb"
          :key="index"
          class="inline-flex items-center"
        >
          <router-link :to="link.url" v-if="link.url">{{ $t(link.title) }}</router-link>
          <span class="text-primary cursor-default" v-else>{{ $t(link.title) }}</span>
          <span class="breadcrumb-separator mx-2 flex items-start">
            <feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" />
          </span>
        </li>
        <li class="inline-flex">
          <span class="cursor-default">{{ this.$t($route.meta.pageTitle) }}</span>
        </li>
      </template>
      <template v-else>
        <li class="inline-flex">
          <span class="cursor-default">{{ this.$t($route.meta.pageTitle) }}</span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: "vx-breadcrumb"
};
</script>